import script from "./TransitionHeight.vue?vue&type=script&setup=true&lang=js"
export * from "./TransitionHeight.vue?vue&type=script&setup=true&lang=js"

import "./TransitionHeight.vue?vue&type=style&index=0&id=1954ecaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1954ecaf"]])

export default __exports__